import * as React from 'react';
import { usePage } from '@inertiajs/react';
import { assetUrl } from '../../utils/assetUrl';
import { route } from '../../utils/route';
import { trackSignupClicked } from '../../utils/tracking';

interface BarriosHeroProps {
  loginUrl: string;
  whatsappUrl: string;
}

export function BarriosHero({}: BarriosHeroProps) {
  const { cdnUrl } = usePage<{ cdnUrl: string }>().props;
  const heroImg = assetUrl(cdnUrl, '/img/barrios-hero.webp');

  return (
    <section className="bp-hero">
      <style>{`
        .bp-hero {
          position: relative;
          background: url(${heroImg}) center center/cover no-repeat;
          padding: 100px 0 110px;
          min-height: 480px;
          display: flex;
          align-items: center;
        }
        .bp-hero::before {
          content: '';
          position: absolute;
          inset: 0;
          background: rgba(0, 0, 0, 0.62);
        }
        .bp-hero-inner {
          position: relative;
          z-index: 1;
          max-width: 800px;
          margin: 0 auto;
          padding: 0 24px;
          text-align: center;
        }
        .bp-hero h1 {
          font-size: 38px;
          font-weight: 800;
          color: #fff;
          margin: 0 0 16px;
          line-height: 1.2;
        }
        .bp-hero .hero-sub {
          font-size: 20px;
          color: rgba(255,255,255,0.9);
          margin: 0 0 12px;
          font-weight: 500;
        }
        .bp-hero .hero-desc {
          font-size: 17px;
          color: rgba(255,255,255,0.75);
          margin: 0 0 36px;
        }
        .bp-hero-ctas {
          display: flex;
          gap: 16px;
          justify-content: center;
          flex-wrap: wrap;
        }
        .bp-btn-primary {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 14px 28px;
          background: #1EAA25;
          color: #fff;
          font-size: 16px;
          font-weight: 600;
          border-radius: 8px;
          text-decoration: none;
          transition: background 0.2s;
        }
        .bp-btn-primary:hover {
          background: #178f1e;
          color: #fff;
          text-decoration: none;
        }
        .bp-btn-secondary {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 14px 28px;
          background: transparent;
          color: #fff;
          font-size: 16px;
          font-weight: 600;
          border: 2px solid rgba(255,255,255,0.6);
          border-radius: 8px;
          text-decoration: none;
          transition: all 0.2s;
        }
        .bp-btn-secondary:hover {
          background: rgba(255,255,255,0.1);
          border-color: #fff;
          color: #fff;
          text-decoration: none;
        }
        @media (max-width: 640px) {
          .bp-hero {
            padding: 70px 0 80px;
            min-height: auto;
          }
          .bp-hero h1 {
            font-size: 28px;
          }
          .bp-hero .hero-sub {
            font-size: 17px;
          }
          .bp-hero-ctas {
            flex-direction: column;
            align-items: stretch;
          }
          .bp-btn-primary, .bp-btn-secondary {
            justify-content: center;
          }
        }
      `}</style>
      <div className="bp-hero-inner">
        <h1>Frutas y verduras frescas en la puerta de tu casa</h1>
        <p className="hero-sub">Delivery directo a barrios privados y countries de Córdoba.</p>
        <p className="hero-desc">Calidad de Mercado de Abasto, sin salir de tu barrio.</p>
        <div className="bp-hero-ctas">
          <a href={route('products.index')} className="bp-btn-primary">
            <i className="fa fa-shopping-basket" /> Ver Productos
          </a>
          <a href={route('login')} className="bp-btn-secondary" onClick={() => trackSignupClicked('barrios-privados', 'hero')}>
            <i className="fa fa-user-plus" /> Crear una cuenta
          </a>
        </div>
      </div>
    </section>
  );
}
